import { Component, signal, output, computed, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultPushNotificationPromptMessage, PushNotificationPrompt } from 'src/app/core/services/push-notifications/push-notifications.service';
import { BellIconSvgComponent } from './bell-icon-svg/bell-icon-svg.component';

@Component({
  standalone: true,
  selector: 'push-notification-panel',
  templateUrl: './push-notification-panel.component.html',
  styleUrls: ['./push-notification-panel.component.scss'],
  imports: [CommonModule, BellIconSvgComponent]
})
export class PushNotificationPanelComponent {

  // Signal-based state management
  private _prompt = signal<PushNotificationPrompt | null>(null);
  readonly prompt = this._prompt.asReadonly();

  // Computed signals for derived state
  readonly hasPrompt = computed(() => !!this._prompt());
  readonly promptTitle = computed(() => this._prompt()?.prompt_title || DefaultPushNotificationPromptMessage.prompt_title);
  readonly promptMessage = computed(() => this._prompt()?.prompt_message || DefaultPushNotificationPromptMessage.prompt_message);
  readonly promptAcceptButtonLabel = computed(() => this._prompt()?.prompt_accept_button_label || DefaultPushNotificationPromptMessage.prompt_accept_button_label);
  readonly promptRejectButtonLabel = computed(() => this._prompt()?.prompt_reject_button_label || DefaultPushNotificationPromptMessage.prompt_reject_button_label);

  @Input() set promptData(value: PushNotificationPrompt) {
    this._prompt.set(value);
  }

  // Update outputs to use Angular 20 output() function
  subscribe$ = output<void>();
  unsubscribe$ = output<void>();

  onSubscribe() {
    this.subscribe$.emit();
  }

  onUnsubscribe() {
    this.unsubscribe$.emit();
  }

  readonly DefaultPushNotificationPromptMessage = DefaultPushNotificationPromptMessage;
}

